// client/src/components/configuracoes/entrega/SecaoEntrega.js
import React from 'react';
import { Truck, MapPin, Plus, Trash2 } from 'lucide-react';
import { useTenantI18n } from '../../../hooks/useAccounts';
import { getCurrencySymbol } from '../../../utils/formatters';

const TIPO_CALCULO_OPTIONS = [
    { value: 'raio',      label: 'Por Raio (km)' },
    { value: 'cep_range', label: 'Por Faixa de CEP' },
    { value: 'fixo',      label: 'Valor Fixo' },
];

// ============================================================
// SEÇÃO ENTREGA
// ============================================================
export const SecaoEntrega = ({
    entrega, setEntrega,
    adicionarFaixaRaio, atualizarFaixaRaio, removerFaixaRaio,
    adicionarFaixaCep, atualizarFaixaCep, removerFaixaCep,
}) => {
    // ✅ ACHADO: rótulos abaixo eram fixos em "(R$)", sem ler
    // configuracoesGerais.i18n da conta.
    const { currency, locale } = useTenantI18n();
    const currencySymbol = getCurrencySymbol(currency, locale);

    return (
    <>
        <div className="form-section">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <h4 className="form-section-title" style={{ marginBottom: 0 }}>
                    <Truck size={15} style={{ marginRight: 5, verticalAlign: 'middle' }} />
                    Habilitar Entrega a Domicílio
                </h4>
                <label className="toggle-switch">
                    <input
                        type="checkbox"
                        checked={entrega.ativo}
                        onChange={e => setEntrega({ ativo: e.target.checked })}
                    />
                    <span className="toggle-slider" />
                </label>
            </div>
        </div>

        {entrega.ativo && (
            <>
                {/* Tipo de cálculo */}
                <div className="form-section">
                    <h4 className="form-section-title">Método de Cálculo do Frete</h4>
                    <div className="form-grid-container-cols-2">
                        <div className="form-group">
                            <label className="form-label">Tipo</label>
                            <select
                                className="form-input"
                                value={entrega.tipoCalculo}
                                onChange={e => setEntrega({ tipoCalculo: e.target.value })}
                            >
                                {TIPO_CALCULO_OPTIONS.map(op => (
                                    <option key={op.value} value={op.value}>{op.label}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                {/* MODO RAIO */}
                {entrega.tipoCalculo === 'raio' && (
                    <>
                        <div className="form-section">
                            <h4 className="form-section-title">Ponto de Origem (coordenadas)</h4>
                            <div className="form-grid-container-cols-2">
                                <div className="form-group">
                                    <label className="form-label">Latitude</label>
                                    <input className="form-input" type="number" step="any" placeholder="-23.5505"
                                        value={entrega.coordenadasBase.latitude}
                                        onChange={e => setEntrega(p => ({ ...p, coordenadasBase: { ...p.coordenadasBase, latitude: e.target.value } }))} />
                                </div>
                                <div className="form-group">
                                    <label className="form-label">Longitude</label>
                                    <input className="form-input" type="number" step="any" placeholder="-46.6333"
                                        value={entrega.coordenadasBase.longitude}
                                        onChange={e => setEntrega(p => ({ ...p, coordenadasBase: { ...p.coordenadasBase, longitude: e.target.value } }))} />
                                </div>
                            </div>
                        </div>

                        <div className="form-section">
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
                                <h4 className="form-section-title" style={{ marginBottom: 0 }}>Faixas de Raio</h4>
                                <button type="button" className="action-button action-button-secondary" onClick={adicionarFaixaRaio}>
                                    <Plus size={18} className="icon" /> Adicionar Faixa
                                </button>
                            </div>
                            {entrega.faixasRaio.length === 0 ? (
                                <div className="table-empty-state">
                                    <MapPin size={36} />
                                    <h3>Nenhuma faixa cadastrada</h3>
                                    <p>Clique em "Adicionar Faixa" para começar.</p>
                                </div>
                            ) : (
                                <div className="table-container" style={{ marginTop: 0 }}>
                                    <div className="table-wrapper">
                                        <table className="styled-table">
                                            <thead>
                                                <tr>
                                                    <th>Raio até (km)</th>
                                                    <th>Valor ({currencySymbol})</th>
                                                    <th>Prazo (h)</th>
                                                    <th>Label</th>
                                                    <th style={{ width: 60, textAlign: 'center' }}>Ativo</th>
                                                    <th style={{ width: 50 }}></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {entrega.faixasRaio.map((f, idx) => (
                                                    <tr key={idx}>
                                                        <td><input className="form-input" type="number" min="0" step="0.1" value={f.raioKm} style={{ width: 90 }}
                                                            onChange={e => atualizarFaixaRaio(idx, 'raioKm', e.target.value)} /></td>
                                                        <td><input className="form-input" type="number" min="0" step="0.01" value={f.valor} style={{ width: 100 }}
                                                            onChange={e => atualizarFaixaRaio(idx, 'valor', e.target.value)} /></td>
                                                        <td><input className="form-input" type="number" min="0" value={f.prazoHoras} style={{ width: 80 }}
                                                            onChange={e => atualizarFaixaRaio(idx, 'prazoHoras', e.target.value)} /></td>
                                                        <td><input className="form-input" type="text" value={f.label} placeholder="Ex: Até 5km" style={{ minWidth: 120 }}
                                                            onChange={e => atualizarFaixaRaio(idx, 'label', e.target.value)} /></td>
                                                        <td style={{ textAlign: 'center' }}>
                                                            <input type="checkbox" checked={f.ativo} onChange={e => atualizarFaixaRaio(idx, 'ativo', e.target.checked)} />
                                                        </td>
                                                        <td>
                                                            <button type="button" className="action-icon-button" data-variant="delete" title="Remover" onClick={() => removerFaixaRaio(idx)}>
                                                                <Trash2 size={16} />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
                )}

                {/* MODO CEP_RANGE */}
                {entrega.tipoCalculo === 'cep_range' && (
                    <div className="form-section">
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
                            <h4 className="form-section-title" style={{ marginBottom: 0 }}>Faixas de CEP</h4>
                            <button type="button" className="action-button action-button-secondary" onClick={adicionarFaixaCep}>
                                <Plus size={18} className="icon" /> Adicionar Faixa
                            </button>
                        </div>
                        {entrega.faixasCep.length === 0 ? (
                            <div className="table-empty-state">
                                <MapPin size={36} />
                                <h3>Nenhuma faixa de CEP cadastrada</h3>
                                <p>Clique em "Adicionar Faixa" para começar.</p>
                            </div>
                        ) : (
                            <div className="table-container" style={{ marginTop: 0 }}>
                                <div className="table-wrapper">
                                    <table className="styled-table">
                                        <thead>
                                            <tr>
                                                <th>CEP Início</th>
                                                <th>CEP Fim</th>
                                                <th>Valor ({currencySymbol})</th>
                                                <th>Prazo (h)</th>
                                                <th>Label</th>
                                                <th style={{ width: 60, textAlign: 'center' }}>Ativo</th>
                                                <th style={{ width: 50 }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {entrega.faixasCep.map((f, idx) => (
                                                <tr key={idx}>
                                                    <td><input className="form-input" type="text" maxLength={9} value={f.cepInicio} placeholder="00000-000" style={{ width: 110 }}
                                                        onChange={e => atualizarFaixaCep(idx, 'cepInicio', e.target.value)} /></td>
                                                    <td><input className="form-input" type="text" maxLength={9} value={f.cepFim} placeholder="99999-999" style={{ width: 110 }}
                                                        onChange={e => atualizarFaixaCep(idx, 'cepFim', e.target.value)} /></td>
                                                    <td><input className="form-input" type="number" min="0" step="0.01" value={f.valor} style={{ width: 100 }}
                                                        onChange={e => atualizarFaixaCep(idx, 'valor', e.target.value)} /></td>
                                                    <td><input className="form-input" type="number" min="0" value={f.prazoHoras} style={{ width: 80 }}
                                                        onChange={e => atualizarFaixaCep(idx, 'prazoHoras', e.target.value)} /></td>
                                                    <td><input className="form-input" type="text" value={f.label} placeholder="Ex: Zona Sul" style={{ minWidth: 120 }}
                                                        onChange={e => atualizarFaixaCep(idx, 'label', e.target.value)} /></td>
                                                    <td style={{ textAlign: 'center' }}>
                                                        <input type="checkbox" checked={f.ativo} onChange={e => atualizarFaixaCep(idx, 'ativo', e.target.checked)} />
                                                    </td>
                                                    <td>
                                                        <button type="button" className="action-icon-button" data-variant="delete" title="Remover" onClick={() => removerFaixaCep(idx)}>
                                                            <Trash2 size={16} />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {/* MODO FIXO */}
                {entrega.tipoCalculo === 'fixo' && (
                    <div className="form-section">
                        <h4 className="form-section-title">Valor Fixo de Entrega</h4>
                        <div className="form-grid-container-cols-2">
                            <div className="form-group">
                                <label className="form-label">Valor ({currencySymbol})</label>
                                <input className="form-input" type="number" min="0" step="0.01"
                                    value={entrega.valorFixo}
                                    onChange={e => setEntrega({ valorFixo: e.target.value })} />
                            </div>
                            <div className="form-group">
                                <label className="form-label">Prazo de Entrega (horas)</label>
                                <input className="form-input" type="number" min="0"
                                    value={entrega.prazoFixoHoras}
                                    onChange={e => setEntrega({ prazoFixoHoras: e.target.value })} />
                            </div>
                        </div>
                    </div>
                )}

                {/* Regras gerais */}
                <div className="form-section">
                    <h4 className="form-section-title">Regras Gerais</h4>
                    <div className="form-grid-container-cols-2">
                        <div className="form-group">
                            <label className="form-label">Valor mínimo do pedido para entrega ({currencySymbol})</label>
                            <input className="form-input" type="number" min="0" step="0.01"
                                value={entrega.valorMinimoCompra}
                                onChange={e => setEntrega({ valorMinimoCompra: e.target.value })} />
                            <small style={{ color: '#64748b', fontSize: '0.8rem' }}>0 = sem valor mínimo</small>
                        </div>
                        <div className="form-group">
                            <label className="form-label">Frete grátis acima de ({currencySymbol})</label>
                            <input className="form-input" type="number" min="0" step="0.01"
                                value={entrega.freteGratisMinimoCompra}
                                onChange={e => setEntrega({ freteGratisMinimoCompra: e.target.value })}
                                placeholder="Vazio = sem frete grátis" />
                        </div>
                    </div>
                </div>

                {/* Instruções */}
                <div className="form-section">
                    <h4 className="form-section-title">Instruções para o Cliente</h4>
                    <div className="form-group">
                        <textarea className="form-input" rows={3}
                            value={entrega.instrucoes}
                            onChange={e => setEntrega({ instrucoes: e.target.value })}
                            placeholder="Ex: Entregas realizadas de segunda a sábado das 9h às 18h." />
                    </div>
                </div>
            </>
        )}
    </>
    );
};

export default SecaoEntrega;
